import { addressUpdates } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";

export default function AddressTimeline() {
  return (
    <section id="address" className="w-full bg-background-100 py-16 md:py-24 border-y border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <span className="text-xs tracking-widest text-accent-700 uppercase">Latest Address</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">最新地址更新记录</h2>
            </div>
            <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
              线路会不定期调整，这里按时间倒序记录每一次变化，需要的时候对照一下就知道该用哪个入口。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12">
          {addressUpdates.map((item, i) => (
            <Reveal key={item.id} delay={i * 70}>
              <div className="flex gap-4 py-5 border-b border-background-200">
                <span className="w-10 h-10 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className="ri-map-pin-2-line text-lg"></i>
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    <h3 className="text-sm text-foreground-900">{item.title}</h3>
                    <time className="text-xs text-foreground-500">{item.date}</time>
                  </div>
                  <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{item.note}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}